import { twMerge } from 'tailwind-merge';
import { Note, Title } from '../atoms';
import CreatorLoginPageImageGIF from '@ui/assets/images/CreatorLoginPageImageGIF.gif';
import FanLoginPageImageGIF from '@ui/assets/images/FanLoginPageImageGIF.gif';

interface IAuthImage {
  title?: string;
  subtitle?: string;
  className?: string;
  userType: 'creator' | 'fan';
}

export function AuthImage({ title, subtitle, className, userType }: IAuthImage) {
  return (
    <div className={`h-full w-full lg:p-4 lg:pr-0`}>
      <div
        className={twMerge(
          'flex h-full justify-center bg-[#FFC5A6] px-4 lg:flex lg:flex-col lg:justify-between lg:rounded-3xl lg:px-14 lg:py-16',
          className,
        )}>
        {/* <img
          src={korcrewLogo.src}
          alt="Korcrew"
          className=" w-[240px] mb-[5.2rem] mt-[6rem] pt lg:m-0 lg:w-[140px]"
        /> */}

        {/* <div className="hidden w-full justify-center lg:flex">
          <CustomImage type="login" className="max-w-lg" />
        </div> */}

        <div className="w-full h-full flex justify-center items-center">
          <img
            src={userType === 'creator' ? CreatorLoginPageImageGIF.src : FanLoginPageImageGIF.src}
            alt="LoginPageImageGIF"
            className="m-auto max-h-[220px] sm:max-h-[300px] lg:max-h-full"
          />
        </div>

        <div className="hidden lg:block">
          {title && <Title type="mm">{title}</Title>}
          {subtitle && <Note type="xl">{subtitle}</Note>}
        </div>
      </div>
    </div>
  );
}
